<template>
  <div v-if="showDetails">
    <div class="row">
      <b-modal
        centered
        ref="dialogWait"
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
        hide-header
        hide-footer
      >
        <div class="center-xs">
          <spinner />
        </div>
        <div class="center-xs pt-3">
          {{ currentLoadingMessage }}
        </div>
      </b-modal>
    </div>

    <div id="details">
      <header id="header" class="row">
        <div :class="`col-xs-12 monit-item ${bgStatus}`">
          <h5 class="mb-0 pt-1">{{ Object.keys(item).length && item.NAME }}</h5>
          <div class="update">
            <clock-icon title="" /> {{ updated }}
            <span v-if="editor">por {{ editor }}</span>
          </div>
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'info' ? 'active' : ''}`"
          @click="selectDetails(0)"
        >
          Informações
        </div>
        <div
          v-if="item.MANAGEMENT"
          :class="`col-xs-6 monit-tabs ${active == 'charts' ? 'active' : ''}`"
          @click="selectDetails(1)"
        >
          Manejo
        </div>
      </header>

      <div v-if="item.MANAGEMENT" class="column details-area px-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <span class="border-0"> Atuador: {{ item.ACTUATOR_NAME }} </span>

          <span class="my-2" />

          <div class="percent-box overflow-hidden">
            <div
              :class="`percent-progress ${bgStatus}`"
              :style="`width: ${calcPercentageRounded(
                item.MANAGEMENT.FINAL_STORAGE,
                item.MANAGEMENT.MAX_STORAGE
              )}%;min-width: 1%;`"
            />

            <span class="percent-text"> Água disponível final </span>
            <span class="percent-ping"> </span>
            <div class="percent-value">
              {{
                calcPercentageRounded(
                  item.MANAGEMENT.FINAL_STORAGE,
                  item.MANAGEMENT.MAX_STORAGE
                )
              }}<span class="percent-unit">%</span>
            </div>
          </div>

          <div class="d-flex my-3 justify-content-around">
            <div class="d-flex flex-column align-items-center">
              <div class="ad-percentage-title">AD inicial:</div>
              <div>
                {{ item.MANAGEMENT.INITIAL_STORAGE }}mm ({{
                  calcPercentageRounded(
                    item.MANAGEMENT.INITIAL_STORAGE,
                    item.MANAGEMENT.MAX_STORAGE
                  )
                }}%)
              </div>
            </div>

            <div class="d-flex flex-column align-items-center">
              <div class="ad-percentage-title">AD final:</div>
              <div>
                {{ item.MANAGEMENT.FINAL_STORAGE }}mm ({{
                  calcPercentageRounded(
                    item.MANAGEMENT.FINAL_STORAGE,
                    item.MANAGEMENT.MAX_STORAGE
                  )
                }}%)
              </div>
            </div>
          </div>

          <div v-if="!item.STATUS.includes('Colhido')" class="mt-5">
            <div class="accordion mb-2" role="tablist">
              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-aa
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Resumo de Atividade do Setor</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-aa"
                  accordion="my-accordion-a"
                  role="tabpanel"
                  visible
                >
                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Para Hoje:
                      </strong>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        :tbody-tr-class="bladeTableClass"
                        fixed
                        outlined
                        :items="scheduleItems"
                        :fields="scheduleFields"
                      >
                      </b-table>
                    </div>
                  </b-card-text>

                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Histórico Até Ontem:
                      </strong>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        fixed
                        outlined
                        :items="baseHistoryItems"
                        :fields="baseHistoryFields"
                      >
                      </b-table>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-d
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Agendas Detalhadas</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>

                <b-collapse
                  id="accordion-d"
                  accordion="my-accordion-a"
                  role="tabpanel"
                >
                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Agenda Sugerida:
                      </strong>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        :tbody-tr-class="bladeTableClass"
                        fixed
                        outlined
                        :items="suggestionScheduleInfo"
                        :fields="scheduleFields"
                      >
                      </b-table>
                    </div>
                  </b-card-text>

                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Agendas Ativas:
                      </strong>
                      <b-table
                        v-if="!loadingDetails"
                        striped
                        table-class="table-agn mb-0"
                        :tbody-tr-class="bladeTableClass"
                        fixed
                        outlined
                        :items="runningSchedulesInfo"
                        :fields="scheduleFields"
                      >
                      </b-table>
                      <div v-else class="p-3">...</div>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-c
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Dados Base do Setor</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-c"
                  accordion="my-accordion-a"
                  role="tabpanel"
                >
                  <b-card-text class="p-3">
                    <div>
                      <div><strong> Dia: </strong> {{ managementDate }}</div>
                      <div>
                        <strong> ID do Setor: </strong> {{ item.ID_SECTOR }}
                      </div>
                      <div>
                        <strong> Cultivar: </strong>
                        {{ item.FARM.NAME || "indefinido" }}
                      </div>

                      <div>
                        <strong> Solo: </strong>
                        {{ item.SOIL.NAME || "Indefinido" }}
                      </div>

                      <div>
                        <strong> Data Inicial de Manejo: </strong>
                        {{
                          formatDate(
                            item.VOLUME_DATE
                              ? item.VOLUME_DATE
                              : item.PLANTING_DATE
                          )
                        }}
                      </div>

                      <div>
                        <strong> Data de Plantio: </strong>
                        {{
                          item.PLANTING_DATE
                            ? formatDate(item.PLANTING_DATE)
                            : "Indefinida"
                        }}
                      </div>

                      <div>
                        <strong> Data de Colheita: </strong>
                        {{
                          item.DATE_CROP
                            ? formatDate(item.DATE_CROP)
                            : "Indefinida"
                        }}
                      </div>

                      <div>
                        <strong> NDC: </strong>
                        {{ calcNDC(item.PLANTING_DATE, item.MANAGEMENT.TIME) }}
                      </div>

                      <div>
                        <strong> DAP: </strong>
                        {{ item.MANAGEMENT.ID_DAP }}
                      </div>

                      <div>
                        <strong> KC: </strong>
                        {{ item.MANAGEMENT.KC }}
                      </div>

                      <div>
                        <strong> Projeção de Rama (m): </strong>
                        {{ item.MANAGEMENT.BRANCH }}
                      </div>

                      <div>
                        <strong> Profundidade de Raiz (cm): </strong>
                        {{ item.MANAGEMENT.DEPTH_ROOT }}
                      </div>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-ca
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Informativos</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-ca"
                  accordion="my-accordion-a"
                  role="tabpanel"
                >
                  <b-card-text class="p-3">
                    <div>
                      <div v-if="!loadingDetails">
                        <div v-if="!sectorInfos.EXCESS_ACCUMULATED">
                          Sem excedente acumulado
                        </div>
                        <div v-if="!sectorInfos.VOLUME_ACCUMULATED">
                          Sem volume acumulado
                        </div>
                        <div v-if="!item.MANAGEMENT.EXCESS">
                          Sem previsão de excedente
                        </div>
                      </div>

                      <div
                        v-if="sectorInfos.EXCESS_ACCUMULATED || loadingDetails"
                      >
                        <strong> Excedente acumulado: </strong>
                        <span v-if="loadingDetails"> ... </span>
                        <span v-else>
                          {{
                            sectorInfos.EXCESS_ACCUMULATED &&
                            sectorInfos.EXCESS_ACCUMULATED.toFixed(2)
                          }}mm
                        </span>
                      </div>

                      <div
                        v-if="sectorInfos.VOLUME_ACCUMULATED || loadingDetails"
                      >
                        <strong> Volume acumulado: </strong>
                        <span v-if="loadingDetails"> ... </span>
                        <span v-else>
                          {{
                            sectorInfos.VOLUME_ACCUMULATED &&
                            sectorInfos.VOLUME_ACCUMULATED.toFixed(2)
                          }}m³
                        </span>
                      </div>

                      <div v-if="item.MANAGEMENT.EXCESS">
                        <strong> Previsão de excedente: </strong>
                        <span v-if="loadingDetails"> ... </span>
                        <span v-else>
                          {{
                            item.MANAGEMENT.EXCESS &&
                            item.MANAGEMENT.EXCESS.toFixed(2)
                          }}mm
                        </span>
                      </div>

                      <span v-if="item.NOTE" class="jump-line">
                        <br />
                        <strong> Observações: </strong>
                        {{ item.NOTE }}
                        <br />
                      </span>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <b-collapse
            id="collapse-4"
            class="mb-1"
            v-model="visible"
            v-if="'INPUTS' in item && item.INPUTS.length"
          >
            <p class="warning-command mt-3">
              <alert-icon /> Utilize os comandos do sensor com cuidado.
            </p>

            <div class="mb-4 mt-4">
              <div
                v-for="button in item.BUTTONS"
                :key="button.name"
                class="buttons"
              >
                <b-button
                  variant="3v3"
                  block
                  @click="buttons(button.COMMAND)"
                  size="sm"
                >
                  {{ button.NAME }}
                </b-button>
              </div>
            </div>
            <!-- COMMANDS -->
          </b-collapse>
        </div>
        <div class="h-100" v-else>
          <div v-if="loadingDetails" class="col-xs-12 center-xs mt-2">
            <spinner /> Aguarde...
          </div>
          <div v-else-if="managementHistory.length" class="h-100">
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="div" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-1
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Gráfico</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  visible
                  accordion="my-accordion-1"
                  role="tabpanel"
                >
                  <b-card-text class="p-2 p-md-3">
                    <history-chart
                      :loading-data="loadingRecalcManagement"
                      :chart-height="accordionItemHeight"
                      :management-history-data="managementHistory"
                      :sensor-history-data="sensorHistoryData"
                      :sector-name="item.NAME"
                    />
                  </b-card-text>
                </b-collapse>
              </b-card>
            </div>

            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="div" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-2
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Histórico de manejo</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion-2"
                  role="tabpanel"
                >
                  <b-card-text class="p-2 p-md-3">
                    <div
                      class="d-flex align-items-center justify-content-between mb-3"
                    >
                      <b-button
                        class="align-items-center font-weight-regular"
                        :class="showDownloadOptions ? null : 'collapsed'"
                        size="sm"
                        id="downloads-options"
                        :variant="
                          historyItemsToBeUpdated &&
                          historyItemsToBeUpdated.length
                            ? 'success'
                            : ''
                        "
                        :aria-expanded="showDownloadOptions ? 'true' : 'false'"
                        aria-controls="collapse-downloads"
                        @click="recalcManagementHandler"
                      >
                        Salvar dados e recalcular manejo
                      </b-button>

                      <b-button
                        class="align-items-center font-weight-regular"
                        :class="showDownloadOptions ? null : 'collapsed'"
                        size="sm"
                        id="downloads-options"
                        variant="success"
                        :aria-expanded="showDownloadOptions ? 'true' : 'false'"
                        aria-controls="collapse-downloads"
                        @click="showDownloadOptions = !showDownloadOptions"
                      >
                        Baixar Planilha
                      </b-button>

                      <b-collapse
                        id="collapse-downloads"
                        v-model="showDownloadOptions"
                        class="mt-1 download-options"
                      >
                        <download-table-content
                          :downloadCSV="downloadCSV"
                          :downloadXLSX="downloadXLSX"
                          :downloadPDF="downloadPDF"
                          :show-json="false"
                          class="py-2 py-lg-2"
                        />
                      </b-collapse>
                    </div>

                    <data-table
                      ref="dataTable"
                      editable
                      sticky-header
                      :max-height-table="`${accordionItemHeight}`"
                      :left-frozen-columns="leftFrozenColumns"
                      :static-columns="staticColumns"
                      :table-data="managementHistory"
                      :file-prefix="`Manejo ${item.NAME}`"
                      @update-table-data="
                        (val) => (historyItemsBeforeUpdate = val)
                      "
                    />
                  </b-card-text>
                </b-collapse>
              </b-card>
            </div>

            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="div" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-3
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Observações do setor</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion-3"
                  role="tabpanel"
                >
                  <b-card-text class="p-2 p-md-3">
                    <div class="mb-4">
                      <div class="d-flex align-items-center mb-2">
                        <div>
                          <div>
                            <b-button
                              v-if="editingSectorNote"
                              variant=""
                              @click="cancelEditSectorNote"
                              size="sm"
                            >
                              Cancelar
                            </b-button>

                            <b-button
                              variant="3v3"
                              @click="editSectorNote"
                              size="sm"
                            >
                              {{ editingSectorNote ? "Salvar" : "Editar" }}
                            </b-button>
                          </div>
                        </div>
                      </div>

                      <p
                        v-if="!editingSectorNote && item.NOTE"
                        :style="`max-height:${accordionItemHeight}`"
                        class="jump-line mb-0 overflow-auto"
                      >
                        {{ item.NOTE }}
                      </p>

                      <div
                        v-else-if="!editingSectorNote && !item.NOTE"
                        class="font-italic"
                      >
                        Não foram adicionadas observações a este setor
                      </div>

                      <div v-else>
                        <b-form-textarea
                          id="textarea"
                          v-model="item.NOTE"
                          placeholder="Observações..."
                          maxlength="65553"
                          rows="5"
                          size="sm"
                        />
                      </div>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <div
            v-else
            class="w-100 d-flex justify-content-center font-weight-bold p-3 p-lg-5"
          >
            Não existem dados a serem mostrados por agora
          </div>
        </div>
      </div>
      <footer id="footer">
        <b-btn
          size="sm"
          block
          @click="$emit('close-details')"
          :class="`close-button ${bgStatus}`"
        >
          Fechar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { GetsSectorSensorsName } from "@/api/modules/sector/useCases/getsSectorSensorsNameUseCase.js";
import { UpdateSectorNote } from "@/api/modules/sector/useCases/updateSectorNoteUseCase.js";
import { GetSensorReportHistoryGraphic } from "@/api/modules/sector/useCases/getSensorReportHistoryGraphicUseCase.js";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import { updateVolumeInput } from "@/api/modules/volume/useCases/updateVolumeInput";
import { updateMultiplesRainfallDataByTimeUseCase } from "@/api/modules/station/updateRainfallByTime";
import { management } from "@/api";
import { calcPercentageRounded } from "@/pages/components/helpers";
import DownloadTableContent from "@/pages/components/shared/table/DownloadTableContent.vue";
import DataTable from "@/pages/components/shared/table/DataTable.vue";
import table from "@/mixins/table";
import moment from "moment";
import { cmd } from "@/api";
import calcManagement from "@/mixins/calcManagement";
import { getManagementByIdSector } from "@/api/modules/management/useCase/getManagementBySector";
import HistoryChart from "./HistoryChart.vue";

export default {
  mixins: [table, calcManagement, managementSectorsActions],
  name: "sector-details",
  components: {
    DownloadTableContent,
    DataTable,
    HistoryChart,
  },
  props: {
    isMobile: Boolean,
    item: Object,
    bgStatus: String,
    updated: String,
    editor: String,
    ending: String,
    showDetails: Boolean,
  },
  data() {
    return {
      baseHistoryItems: [],
      defaultBaseHistoryItems: [
        {
          RANGE_DAYS: 1,
          IRRIGATED_BLADE: 0,
          VOLUME: 0,
          RAINFALL: 0,
        },
        {
          RANGE_DAYS: 7,
          IRRIGATED_BLADE: 0,
          VOLUME: 0,
          RAINFALL: 0,
        },
        {
          RANGE_DAYS: 30,
          IRRIGATED_BLADE: 0,
          VOLUME: 0,
          RAINFALL: 0,
        },
      ],
      scheduleDetails: [],
      sensorHistoryData: [],
      editingSectorNote: false,
      itemNoteBeforeEdit: "",
      loadingRecalcManagement: false,
      historyItemsBeforeUpdate: [],
      sectorInfos: {},
      managementHistory: [],
      showDownloadOptions: false,
      loadingDetails: true,
      currentLoadingMessage: "",
      leftFrozenColumns: [
        {
          title: "DIA",
          field: "TIME",
          minWidth: 120,
          maxWidth: 120,
          formatter: (cell) => moment(cell.getValue()).format("DD/MM/YYYY"),
          accessorDownload: (val) => moment(val).format("DD/MM/YYYY"),
        },
      ],
      staticColumns: [
        {
          title: "NDC",
          field: "NDC",
          minWidth: 90,
          width: 90,
          accessorDownload: (val) => val,
          editable: false,
        },
        {
          title: "DAP",
          field: "ID_DAP",
          minWidth: 90,
          width: 90,
          accessorDownload: (val) => val,
          editable: false,
        },
        {
          title: "KC",
          field: "KC",
          minWidth: 90,
          width: 90,
          accessorDownload: (val) => val,
          editable: false,
        },
        {
          title: "ET0 (mm)",
          field: "ET0",
          minWidth: 90,
          maxWidth: 90,
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Precipitação (mm)",
          field: "RAINFALL",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Precipitação Alegada (mm)",
          field: "RAINFALL_INPUT",
          editorParams: {
            allowEmpty: true,
          },
          mutatorEdit: function (value, data, type) {
            return value == "" ? null : value;
          },
          formatter: (cell) => {
            // const rainfallFieldVal = cell.getData().RAINFALL;
            const rainfallInputFieldVal = cell.getValue();
            const fieldVal =
              rainfallInputFieldVal !== null ? rainfallInputFieldVal : "-";
            const isMoreThanRainfallField = typeof fieldVal === "number";

            return `
              <span
                class="${isMoreThanRainfallField ? "font-weight-bold" : ""}"
                style="${isMoreThanRainfallField ? "color:#981b1b" : ""}"
              >
                ${fieldVal}
              </span>
            `;
          },
          validator: (cell, value) => {
            return value === "-" || value >= 0;
          },
          accessorDownload: (val, row) => {
            return this.decimalFormatter(val != null ? val : "-");
          },
        },
        {
          title: "Volume (m³)",
          field: "VOLUME",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Volume Alegado (m³)",
          field: "VOLUME_INPUT",
          formatter: (cell) => {
            const volumeFieldVal = cell.getData().VOLUME;
            const volumeInputFieldVal = cell.getValue();

            const fieldVal =
              volumeInputFieldVal != "" &&
              volumeInputFieldVal != null &&
              volumeInputFieldVal != volumeFieldVal
                ? volumeInputFieldVal
                : "-";
            const isMoreThanVolumeField = typeof fieldVal === "number";

            return `
              <span
                class="${isMoreThanVolumeField ? "font-weight-bold" : ""}"
                style="${isMoreThanVolumeField ? "color:#981b1b" : ""}"
              >
                ${fieldVal}
              </span>
            `;
          },
          validator: (cell, value) => {
            return (
              value === "" || value === "-" || value >= cell.getData().VOLUME
            );
          },
          accessorDownload: (val, row) => {
            const volumeFieldVal = row.VOLUME;
            return this.decimalFormatter(val != volumeFieldVal ? val : "-");
          },
        },
        {
          title: "Lâmina Aplicada (mm)",
          field: "IRRIGATED_BLADE",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Lâmina Sugerida (mm)",
          field: "BLADE_SUGGESTION",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Armazenamento Inicial (mm)",
          field: "INITIAL_STORAGE",
          visible: false,
          download: true,
          accessorDownload: (val) => this.decimalFormatter(val),
          editable: false,
        },
        {
          title: "Armazenamento Final (mm)",
          field: "FINAL_STORAGE",
          accessorDownload: (val) => this.decimalFormatter(val),
          editable: false,
        },
        {
          title: "Armazenamento Máximo (mm)",
          field: "MAX_STORAGE",
          accessorDownload: (val) => this.decimalFormatter(val),
          editable: false,
        },
        {
          title: "Disponibilidade de Água (%)",
          field: "WATER_DISPONIBILITY",
          minWidth: 160,
          width: 160,
          tooltip: (cell) => {
            return (
              `Água disponível: ${this.calcPercentageRounded(
                cell.getData().FINAL_STORAGE,
                cell.getData().MAX_STORAGE
              )}% (${cell.getData().FINAL_STORAGE}mm)` +
              `\npara armazenamento máximo de: ${cell.getData().MAX_STORAGE}mm`
            );
          },
          formatter: (cell) => {
            const currentSector = this.item;

            const storagePercentage = this.calcPercentageRounded(
              cell.getData().FINAL_STORAGE,
              cell.getData().MAX_STORAGE
            );

            const availability =
              (1 - currentSector.MANAGEMENT.AVAILABILITY) * 100;

            let bgColor = "bg-";

            if (storagePercentage <= availability) {
              bgColor += "danger";
            } else if (
              storagePercentage <=
              (100 - availability) / 2 + availability
            ) {
              bgColor += "warning";
            } else {
              bgColor += "3v3";
            }

            return `
              <div
                data-max="100"
                data-min="0"
                class="${bgColor}"
                style="display: inline-block;
                position: relative;
                width: ${storagePercentage}%;
                height: 100%;" >
              </div>`;
          },
          accessorDownload: (val, rowData) => {
            return this.calcPercentageRounded(
              rowData.FINAL_STORAGE,
              rowData.MAX_STORAGE
            );
          },
          hozAlign: "start",
          editable: false,
        },
        {
          title: "Excedente (mm)",
          field: "EXCESS",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
      ],
      active: "info",
      visible: false,
    };
  },
  mounted() {
    window.onclick = (event) => {
      if (
        event.target.id != "collapse-downloads" &&
        event.target.id != "downloads-options" &&
        this.showDownloadOptions
      ) {
        this.showDownloadOptions = false;
      }
    };
  },
  watch: {
    loadingRecalcManagement: {
      handler(newValue) {
        if (newValue) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
        }
      },
    },
    managementHistory: {
      deep: true,
      handler(newValue, oldValue) {
        const isFirstTimeRendering =
          oldValue && newValue && !oldValue.length && newValue.length;

        if (isFirstTimeRendering) {
          this.historyItemsBeforeUpdate = JSON.parse(JSON.stringify(newValue));
        }
      },
    },
    showDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    active: {
      deep: true,
      immediate: true,
      async handler(newValue, oldValue) {
        this.baseHistoryItems = this.defaultBaseHistoryItems;
        this.showDetailsActuators(newValue);
        if (newValue == "charts" && this.item.MANAGEMENT) {
          this.loadingDetails = true;
          await this.getManagementHistoryData();
        }
      },
    },
    item: {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          this.editingSectorNote = false;
          this.itemNoteBeforeEdit = newValue.NOTE;
          await this.setSectorDetailsHistoryBase();
          await this.getSectorInfos();
          this.managementHistory = [];
        }

        if (
          Object.keys(newValue).length &&
          oldValue &&
          newValue.ID != oldValue.ID
        ) {
          this.active = "info";
        }
      },
    },
    isMobile() {
      this.showDetailsActuators(this.active);
    },
  },
  methods: {
    moment,
    async setSectorDetailsHistoryBase() {
      try {
        const rangeDaysList = this.defaultBaseHistoryItems.map(
          (historyItem) => historyItem.RANGE_DAYS
        );

        const baseHistoryData = await management.getDetailsBaseHistory({
          idSector: this.item.ID_SECTOR,
          rangeDaysList,
        });

        this.baseHistoryItems = baseHistoryData.map((rangeDay) => {
          rangeDay.RAINFALL = rangeDay.RAINFALL
            ? rangeDay.RAINFALL.toFixed(2)
            : 0;
          rangeDay.VOLUME = rangeDay.VOLUME ? rangeDay.VOLUME.toFixed(2) : 0;
          rangeDay.IRRIGATED_BLADE = rangeDay.IRRIGATED_BLADE
            ? rangeDay.IRRIGATED_BLADE.toFixed(2)
            : 0;

          return rangeDay;
        });
      } catch (e) {
        this.baseHistoryItems = this.defaultBaseHistoryItems;

        console.error(
          "Ocorreu um erro ao solicitar o historico base do setor",
          e
        );
        alert("Ocorreu um erro ao solicitar o historico base do setor", "e");
      }
    },
    bladeTableClass(item, type) {
      if (!item || type !== "row") return;
      if (this.item.MANAGEMENT.STRESS && item.is_suggestion_blade) {
        return "bg-red text-white";
      }
    },
    bladeToMinutes(blade) {
      const hasAverage = !!this.item.FLOW_AVG;
      let blade_suggestion_minutes = 0;

      if (hasAverage) {
        blade_suggestion_minutes =
          (this.bladeToVol(blade) / this.item.FLOW_AVG) * 60;
      } else {
        blade_suggestion_minutes =
          (blade * 60) / this.transmissivity / this.item.APPLICATION_RATE;
      }

      return Math.round(blade_suggestion_minutes);
    },
    bladeToVol(blade) {
      return this.lam2vol(blade, Number(this.item.AREA), this.transmissivity);
    },
    async getManagementHistoryData() {
      await getManagementByIdSector()
        .execute(this.item.ID_SECTOR)
        .then((history) => {
          const historyCalculated = history.map((row) => {
            row.NDC = this.calcNDC(this.item.PLANTING_DATE, row.TIME);

            return row;
          });

          this.managementHistory = historyCalculated;

          this.historyItemsBeforeUpdate = JSON.parse(
            JSON.stringify(this.managementHistory)
          );

          return historyCalculated;
        })
        .then(async (history) => {
          const sectorSensorsName = await new GetsSectorSensorsName().execute(
            this.item.ID_SECTOR
          );
          const sensorsHistorys = [];

          for (const sensor of sectorSensorsName) {
            const sensorHistoryAvg =
              await new GetSensorReportHistoryGraphic().execute(
                sensor.SENSOR_NAME,
                {
                  start: history[0].TIME,
                  end: history[history.length - 1].TIME,
                }
              );

            if (sensorHistoryAvg && sensorHistoryAvg.length) {
              // Filling up days with no occurencies with 0

              const sensorDaysMapped = history.map((managementDay) => {
                const daySensorRead = sensorHistoryAvg.find(
                  (day) =>
                    moment(day.TIME).format("YYYY-MM-DD") ==
                    moment(managementDay.TIME).format("YYYY-MM-DD")
                );

                return {
                  VALUE: daySensorRead ? daySensorRead.VALUE : 0,
                  TIME: managementDay.TIME,
                  SENSOR_NAME: sensorHistoryAvg[0].SENSOR_NAME,
                };
              });

              sensorsHistorys.push(sensorDaysMapped);
            }
          }

          this.sensorHistoryData = sensorsHistorys;
        })
        .finally(() => (this.loadingDetails = false));
    },
    cancelEditSectorNote() {
      this.editingSectorNote = false;
      this.item.NOTE = this.itemNoteBeforeEdit;
    },
    async editSectorNote() {
      if (this.editingSectorNote) {
        return await new UpdateSectorNote()
          .execute(this.item.ID_SECTOR, this.item.NOTE)
          .then((r) => {
            this.editingSectorNote = false;
            this.itemNoteBeforeEdit = this.item.NOTE;
            return alert("Sucesso ao salvar nova observação do setor", "s");
          })
          .catch((err) => {
            return alert("Erro ao salvar nova observação do setor", "e");
          });
      }

      this.editingSectorNote = true;
    },
    async recalcManagementHandler() {
      if (
        !this.historyItemsToBeUpdated ||
        !this.historyItemsToBeUpdated.length
      ) {
        return;
      }

      this.loadingRecalcManagement = true;
      this.currentLoadingMessage = "Salvando valores inseridos de volume...";

      await this.updateAllVolumesInput();

      this.currentLoadingMessage = "Recalculando dados de manejo...";

      const managementData = await this.recalcManagementData(this.item);

      if (managementData.length) {
        this.currentLoadingMessage = "Salvando dados recalculados de manejo...";
        await this.registerManagement(this.item.ID_SECTOR, managementData);
      }

      await this.getManagementHistoryData();

      this.loadingRecalcManagement = false;
      return alert("Sucesso ao recalcular o manejo", "s");
    },
    async updateAllVolumesInput() {
      try {
        await Promise.all(
          this.historyItemsToBeUpdated.map(async (itemToUpdate) => {
            const [VALUE, FK_VALVE, FK_SECTOR, TIME] = [
              itemToUpdate.VOLUME_INPUT,
              this.item.ID_VALVE,
              this.item.ID_SECTOR,
              itemToUpdate.TIME,
            ];

            await updateVolumeInput({ VALUE, FK_VALVE, TIME, FK_SECTOR });
          })
        );

        return alert("Sucesso ao salvar dados de volume", "s");
      } catch (e) {
        return alert("Erro ao salvar dados de volume", "e");
      }
    },
    async updateAllRainfallInput() {
      try {
        await updateMultiplesRainfallDataByTimeUseCase.execute({
          FK_STATION: 230,
          DATA: this.historyItemsToBeUpdated,
        });
        return alert("Sucesso ao salvar dados de precipitação", "s");
      } catch (e) {
        console.error(e);
        return alert("Erro ao salvar dados de precipitação", "e");
      }
    },
    async recalcManagementData(sector) {
      try {
        const MANAGEMENT = {
          APPLICATION_RATE: sector.APPLICATION_RATE,
          AVG_TIME_PULSE: sector.AVG_TIME_PULSE,
          DATE_CROP: sector.DATE_CROP,
          ID_FARM: sector.FARM.ID,
          ID_SECTOR: sector.ID_SECTOR,
          ID_SOIL: sector.SOIL.ID,
          IS_MANAGEMENT: 1,
          PRESSURIZE_TIME: sector.PRESSURIZE_TIME,
          SECTOR_NAME: sector.NAME,
          SPACING_BETWEEN_LINES: sector.SPACING_BETWEEN_LINES,
          SPACING_BETWEEN_PLANTS: sector.SPACING_BETWEEN_PLANTS,
          SYSTEM_EFFICIENCY: sector.SYSTEM_EFFICIENCY,
          TIME_ADVANCE: sector.TIME_ADVANCE,
          VOLUME_DATE: sector.VOLUME_DATE,
          INITIAL_STORAGE:
            (this.historyItemsBeforeUpdate &&
              this.historyItemsBeforeUpdate[0].INITIAL_STORAGE) ||
            0,
        };

        const SECTOR = {
          ...sector,
          valves: [
            {
              ID: sector.ID_VALVE,
              NAME: sector.ACTUATOR_NAME,
            },
          ],
        };

        const SECTOR_PROPS = { SECTOR, MANAGEMENT };
        const rainfallInputsChanged = this.managementHistory.map((row) => {
          return {
            TIME: row.TIME,
            VALUE: row.RAINFALL_INPUT === "" ? null : row.RAINFALL_INPUT,
          };
        });

        const calculatedData = await this.calcManagementData(
          SECTOR_PROPS,
          rainfallInputsChanged
        );

        alert("Sucesso ao recalcular dados de manejo", "s");

        return calculatedData;
      } catch (e) {
        alert("Erro ao recalcular dados de manejo", "e");
        console.error(e);

        return [];
      }
    },
    calcPercentageRounded,
    async getSectorInfos() {
      this.loadingDetails = true;

      let rawSectorDetails = `
        SELECT
          SUM(EXCESS) EXCESS_ACCUMULATED,
          SUM(VOLUME) VOLUME_ACCUMULATED
        FROM CROP.MANAGEMENT MANAGEMENT
        WHERE (
          ID_SECTOR = ${this.item.ID_SECTOR}
          AND DATE(NOW()) > DATE(MANAGEMENT.TIME)
        );
      `;

      let rawScheduleDetails = `
        SELECT
        AGN_INFOS.NAME,
        SUM(AGN_INFOS.DURATION) DURATION
      FROM (
        SELECT
          AGN_TIME.NAME,
          AGN_DURATION.TIME DURATION
        FROM NEWSIR.AGN_VALVE AGN_VALVE
        JOIN NEWSIR.AGN_TIME AGN_TIME
        ON AGN_VALVE.FK_AGN = AGN_TIME.ID
        JOIN NEWSIR.AGN_DURATION AGN_DURATION
        ON AGN_DURATION.ID = AGN_VALVE.FK_DURATION
        WHERE (
          AGN_VALVE.FK_VALVE = ${this.item.ID_VALVE}
          AND DATE(AGN_TIME.START_DATE) <= DATE(NOW())
            AND IF(ISNULL(AGN_TIME.END_DATE), TRUE, DATE(AGN_TIME.END_DATE) >= DATE(NOW()))
            AND (AGN_TIME.ACTIVITY_DAYS & POWER(2, (DAYOFWEEK(NOW()) - 1 ))) =  POWER(2, (DAYOFWEEK(NOW()) - 1 ))
        )
      ) AGN_INFOS
      GROUP BY AGN_INFOS.NAME
      `;

      const sectorInfos = await new Promise((resolve, reject) => {
        management
          .sql({
            data: {
              sql: rawSectorDetails,
            },
          })
          .then((ret) => {
            if (ret[0] && ret[0][0] && ret[0][0]) {
              resolve(ret[0][0]);
            } else {
              resolve({});
            }
          })
          .catch((err) => {
            console.log(err);
            reject({});
          });
      });

      this.sectorInfos = sectorInfos;

      const scheduleDetails = await new Promise((resolve, reject) => {
        management
          .sql({
            data: {
              sql: rawScheduleDetails,
            },
          })
          .then((ret) => {
            if (ret[0] && ret[0][0] && ret[0][0]) {
              resolve(ret[0]);
            } else {
              resolve([]);
            }
          })
          .catch((err) => {
            console.log(err);
            reject([]);
          });
      });

      this.scheduleDetails = scheduleDetails;

      this.loadingDetails = false;
    },
    downloadCSV() {
      return this.$refs.dataTable ? this.$refs.dataTable.downloadCSV() : "";
    },
    downloadXLSX() {
      return this.$refs.dataTable ? this.$refs.dataTable.downloadXLSX() : "";
    },
    downloadPDF() {
      return this.$refs.dataTable ? this.$refs.dataTable.downloadPDF() : "";
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    showDetailsActuators(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "charts") {
        let width = this.isMobile ? "100%" : "calc(100% - 51px)";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      }
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    sendButton(i, btn) {
      let newCMD = btn.CMD.concat(" ", this.$refs.input[i].$el.value);
      this.buttons(newCMD);
    },
    getResFw(file) {
      setTimeout((_) => {
        cmd
          .resfw(file)
          .then((ret) => {
            if (ret.status) {
              wait.hide();
              if (ret.value == "0") console.log("Sucesso na solicitação");
              else console.log("Falha na soliticação");
            } else {
              if (this.errFwRes < 5) {
                this.errFwRes++;
                console.log(
                  `Erro ao tentar ler arquivo. Tentativa: ${this.errFwRes}`
                );
                this.getResFw(file);
              } else {
                wait.hide();
                console.log("Falha na solicitação");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            wait.hide();
          });
      }, 2000);
    },
    buttons(command) {
      let SET = true;
      let CMD = command;
      let data = { SET, CMD };
      this.changeProp(data, "reqofw");
    },
    changeProp(data, apiFunction) {
      data.ITEM = this.item.ID;
      wait.show();
      cmd[apiFunction](data)
        .then((ret) => {
          if (ret.status) {
            let FILE = ret.value;
            this.getResFw({ FILE });
          } else {
            console.log(ret.log);
            wait.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
  },
  computed: {
    transmissivity() {
      return this.item.SYSTEM_EFFICIENCY * this.item.SOIL.TRANSMISSIVITY;
    },
    managementDate() {
      return moment(this.item.MANAGEMENT.TIME).format("DD/MM/YYYY");
    },
    scheduleItems() {
      const currentAgnVolumePreview =
        this.item &&
        this.item.SCHEDULE &&
        this.item.SCHEDULE.SCHEDULE_VOLUME_PREVIEW &&
        this.item.SCHEDULE.SCHEDULE_VOLUME_PREVIEW.toFixed(2);
      const bladeSuggestionBase = Math.abs(
        this.item.MANAGEMENT.ETR_PREDICTION.toFixed(2)
      );
      let negativeAcc = Number(
        (this.item.MANAGEMENT.BLADE_SUGGESTION - bladeSuggestionBase).toFixed(2)
      );
      negativeAcc > 0 ? negativeAcc : 0;

      const isStressDay = !!this.item.MANAGEMENT.STRESS;

      return [
        {
          agn_name: "Atual",
          blade: this.item.MANAGEMENT.IRRIGATED_BLADE,
          volume:
            currentAgnVolumePreview > 0
              ? currentAgnVolumePreview
              : this.bladeToVol(this.item.MANAGEMENT.IRRIGATED_BLADE),
          duration:
            (this.item.SCHEDULE && this.item.SCHEDULE.SCHEDULE_DURATION) || 0,
        },
        {
          is_suggestion_blade: true,
          agn_name: `Sugerida${isStressDay ? "\n(Estresse)" : ""}`,
          blade:
            this.item.MANAGEMENT.BLADE_SUGGESTION && !isStressDay
              ? this.item.MANAGEMENT.BLADE_SUGGESTION
              : 0,
          volume:
            this.item.MANAGEMENT.BLADE_SUGGESTION && !isStressDay
              ? this.bladeToVol(this.item.MANAGEMENT.BLADE_SUGGESTION)
              : 0,
          duration:
            this.item.MANAGEMENT.BLADE_SUGGESTION && !isStressDay
              ? this.bladeToMinutes(this.item.MANAGEMENT.BLADE_SUGGESTION)
              : 0,
        },
      ];
    },
    suggestionScheduleInfo() {
      const bladeSuggestionBase =
        this.item.MANAGEMENT.ID_DAP <= 1
          ? this.item.MANAGEMENT.BLADE_SUGGESTION
          : Math.abs(this.item.MANAGEMENT.ETR_PREDICTION.toFixed(2));
      let negativeAcc = Number(
        (this.item.MANAGEMENT.BLADE_SUGGESTION - bladeSuggestionBase).toFixed(2)
      );
      negativeAcc > 0 ? negativeAcc : 0;

      return [
        {
          agn_name: "Pendente",
          blade: negativeAcc,
          volume: negativeAcc ? this.bladeToVol(negativeAcc) : 0,
          duration: negativeAcc ? this.bladeToMinutes(negativeAcc) : 0,
        },
        {
          agn_name: "Hoje",
          blade: bladeSuggestionBase,
          volume: this.bladeToVol(bladeSuggestionBase),
          duration: bladeSuggestionBase
            ? this.bladeToMinutes(bladeSuggestionBase)
            : 0,
        },
      ];
    },
    runningSchedulesInfo() {
      const bladeSuggestionBase = Math.abs(
        this.item.MANAGEMENT.ETR_PREDICTION.toFixed(2)
      );
      let negativeAcc = Number(
        (this.item.MANAGEMENT.BLADE_SUGGESTION - bladeSuggestionBase).toFixed(2)
      );
      negativeAcc > 0 ? negativeAcc : 0;

      return this.scheduleDetails.length && this.scheduleItems.length
        ? this.scheduleDetails.map((level) => {
            const currentSchedule = this.scheduleItems[0];
            const percentage =
              level.DURATION / this.item.SCHEDULE.SCHEDULE_DURATION;

            return {
              agn_name: level.NAME,
              blade: (percentage * currentSchedule.blade).toFixed(2) || "-",
              volume: (percentage * currentSchedule.volume).toFixed(2) || "-",
              duration: level.DURATION,
            };
          })
        : [];
    },
    scheduleFields() {
      return [
        { key: "agn_name", label: "Agenda", class: "text-aln-center" },
        { key: "duration", label: "Duração\n(min)", class: "text-aln-center" },
        {
          key: "blade",
          label: "Lâmina líquida\n(mm)",
          class: "text-aln-center",
        },
        {
          key: "volume",
          label: "Volume Previsto\n(m³)",
          class: "text-aln-center",
        },
      ];
    },
    baseHistoryFields() {
      return [
        {
          key: "RANGE_DAYS",
          label: "Dias em análise",
          class: "text-aln-center",
        },
        {
          key: "RAINFALL",
          label: "Pluviometria\n(mm)",
          class: "text-aln-center",
        },
        {
          key: "IRRIGATED_BLADE",
          label: "Lâmina líquida\n(mm)",
          class: "text-aln-center",
        },
        { key: "VOLUME", label: "Volume\n(m³)", class: "text-aln-center" },
      ];
    },
    accordionItemHeight() {
      const windowWidth = window.screen.width;
      const headerSize = "150px";

      if (windowWidth >= 1200) {
        return `calc(65vh - ${headerSize}`;
      } else if (windowWidth >= 768) {
        return `calc(65vh - ${headerSize}`;
      } else {
        return `calc(65vh - ${headerSize}`;
      }
    },
    historyItemsToBeUpdated() {
      const changedValues = this.managementHistory
        .map((row) => {
          if (row.VOLUME_INPUT === "" || row.VOLUME_INPUT === "-") {
            row.VOLUME_INPUT = row.VOLUME;
          }

          if (row.RAINFALL_INPUT === "" || row.RAINFALL_INPUT === "-") {
            row.RAINFALL_INPUT = row.RAINFALL;
          }
          return row;
        })
        .filter((row, index) => {
          const hasChangedVolume =
            row.VOLUME_INPUT !=
            this.historyItemsBeforeUpdate[index].VOLUME_INPUT;

          const hasChangedRainfall =
            row.RAINFALL_INPUT !==
            this.historyItemsBeforeUpdate[index].RAINFALL_INPUT;

          if (hasChangedRainfall || hasChangedVolume)
            return hasChangedRainfall || hasChangedVolume;
        });

      return (
        this.historyItemsBeforeUpdate &&
        this.historyItemsBeforeUpdate.length &&
        changedValues
      );
    },
    blade_suggestion_minutes() {
      const hasAverage = !!this.item.FLOW_AVG;
      let blade_suggestion_minutes = 0;

      if (hasAverage) {
        blade_suggestion_minutes =
          (this.vol_from_blade_suggestion / this.item.FLOW_AVG) * 60;
      } else {
        blade_suggestion_minutes =
          (this.item.MANAGEMENT.BLADE_SUGGESTION * 60) /
          this.transmissivity /
          this.item.APPLICATION_RATE;
      }

      return Math.round(blade_suggestion_minutes);
    },
    vol_from_blade_suggestion() {
      return this.lam2vol(
        this.item.MANAGEMENT.BLADE_SUGGESTION,
        Number(this.item.AREA),
        this.transmissivity
      );
    },
    getBladeSuggestion() {
      let today = moment().format("YYYY-MM-DD");
      if (this.item.PLANTING_DATE === today) {
        return this.item.FARM.LAMINA;
      }
      return this.item.MANAGEMENT && this.item.MANAGEMENT.BLADE_SUGGESTION
        ? this.item.MANAGEMENT.BLADE_SUGGESTION
        : 0;
    },
  },
};
</script>

<style scoped>
.table-agn >>> .text-aln-center {
  text-align: center !important;
  vertical-align: middle !important;
}

.jump-line {
  white-space: pre-line;
}

.download-options {
  position: absolute;
  background: white;
  padding: 5px;
  right: 0;
  margin: 0 10px;
  z-index: 99;
  min-width: 10em;
  max-width: 15em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 4px;
}
.ad-percentage-title {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  margin-top: 2px;
  color: var(--text-gray-primary);
  font-size: 1em;
}
.close-button {
  border: none;
  width: 100%;
  border-radius: 4px;
  color: #ffff;
  outline: none;
}
.close-button:hover {
  filter: contrast(80%);
}
.buttons {
  margin-top: 5px;
}
.container-command div + div {
  margin-top: 6px;
}
.warning-command {
  font-size: 0.8em;
  color: #616161;
  margin-bottom: 0px;
  padding: 8px;
  background-color: #f5f7a593;
  border-radius: 4px;
}
.warning-command .material-design-icon {
  font-size: 0.9em !important;
}
.container-command .cmd-button {
  margin-right: 0px;
}
.label {
  padding: 0;
  font-size: 0.8em;
  /* margin: 0; */
}
.status {
  background: #d0ddcca6;
  border-radius: 4px;
}
.obs-info {
  text-align: center;
  font-size: 0.68em;
}
.percent-box {
  background-color: #8a8a8a;
  border-radius: 10px;
}
.percent-progress {
  border-radius: 10px;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.percent-text,
.percent-value {
  z-index: 2;
}
@keyframes bar-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 80px 80px;
  }
}
.monit-tabs {
  transition: all 0.5s ease;
}
.dir-id {
  font-size: 0.85em;
}
.percent-ping {
  right: 8px;
  z-index: 33;
}
.ios .btn {
  margin: 5px 0;
}
.ios .max-table-height {
  max-height: 300px;
  overflow: auto;
}

.accordion button.btn.btn-3v3 > .arrow-suffix {
  content: "";
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #dffad0;
  font-size: 0;
  line-height: 0;
  transition: transform 0.4s;
}

.accordion button.btn.btn-3v3:not(.collapsed) > .arrow-suffix {
  transform: rotate(-90deg);
}

.accordion >>> td,
.accordion >>> th {
  padding: 0.5rem !important;
}
</style>
